import React from 'react';
import { Link } from 'react-router-dom';
import { ConstructionIcon, ArrowRightIcon } from 'lucide-react';
interface PlaceholderProps {
  title: string;
  description: string;
}
export function Placeholder({
  title,
  description
}: PlaceholderProps) {
  return <main className="paper-texture" data-id="element-386" data-mp="1cmgauakag2u0">
      <div className="mx-auto max-w-3xl px-4 py-24 text-center md:px-8" data-id="element-387" data-mp="1hn49nierdnys">
        <span className="inline-flex items-center gap-2 border-[3px] border-noir bg-jaune px-3 py-1 font-display text-xs uppercase tracking-[0.14em]" data-id="element-388" data-mp="25d8bplcatfno">
          <ConstructionIcon className="h-4 w-4" aria-hidden="true" data-id="element-389" data-mp="2ab056jsld9tz" />
          Page en préparation
        </span>
        <h1 className="mt-6 font-display text-4xl uppercase leading-[0.95] md:text-6xl" data-id="element-390" data-mp="1veiw5z7vk7al">{title}</h1>
        <p className="mx-auto mt-5 max-w-xl text-lg text-noir/70" data-id="element-391" data-mp="20cajefxkr58g">{description}</p>
        <div className="mt-10 flex flex-wrap justify-center gap-3" data-id="element-392" data-mp="jz3yet7udbef">
          <Link to="/commander" className="inline-flex items-center gap-2 border-[3px] border-noir bg-rouge px-5 py-3 font-display text-sm uppercase text-creme shadow-hard-sm transition-transform duration-150 ease-out hover:-translate-y-0.5" data-id="element-393" data-mp="ozhvxhbth2y7">
            Commander en ligne
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-394" data-mp="duedpsv0cgo1" />
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 border-[3px] border-noir bg-creme px-5 py-3 font-display text-sm uppercase shadow-hard-sm transition-transform duration-150 ease-out hover:-translate-y-0.5" data-id="element-395" data-mp="8ujodtqvrz53">
            Retour à l’accueil
          </Link>
        </div>
      </div>
    </main>;
}